import Vue from 'vue';

Vue.filter('tag', (tags, group) => {
  if (!Array.isArray(tags)) return;

  const filteredTags = tags.filter(tag => tag.group === group);

  return filteredTags.map(filteredTag => filteredTag.value).join(', ');
});